import { extend, localize } from 'vee-validate';
import * as all from 'vee-validate/dist/rules';
import nl from 'vee-validate/dist/locale/nl.json';
import i18n from '../utils/locale';

for (const rule of Object.keys(all)) {
    extend(rule, all[rule]);
}

extend('password', {
    validate: (value) => {
        // Test mixed case
        if (!/([a-z]+.*[A-Z])|([A-Z]+.*[a-z])/.test(value)) {
            return false;
        }

        // Test letters
        if (!/[a-z]/.test(value)) {
            return false;
        }

        // Test numbers
        if (!/[0-9]/.test(value)) {
            return false;
        }

        return true;
    },

    message: (field) => {
        return i18n.t('validation.password', {
            field,
        });
    },
});

extend('contains', {
    validate: (value, options) => {
        if (!value) {
            return false;
        }

        return options.every(option => value.includes(option));
    },

    message: (field, attributes) => {
        const fieldValue = attributes._value_;
        const missing = Object.entries(attributes)
            .filter(([key]) => {
                return key.substring(0, 1) !== '_';
            })
            .filter(([_, value]) => !fieldValue.includes(value))
            .map(([_, value]) => value);

        return i18n.t('validation.contains', {
            field,
            missing: missing.join(', '),
        });
    },
});


localize({
    nl,
});

localize('nl');
